import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import type { History } from 'history';
import { responsiveStoreEnhancer } from 'redux-responsive';
import { routerMiddleware } from 'connected-react-router';

import { getViewInitialState } from 'src/store/view/reducer';

import { isWebGlSupported } from 'src/utils/mapUtils';
import { makeMockTourists } from 'src/utils/mockUtils';

import { DEFAULT_TOPBAR_SLIDE } from 'src/constants';

import { visaDTO } from 'checkout/store/domains/visa/visaDTO';
import { packageDTO } from 'checkout/store/package/packageDTO';
import { orderDTO } from 'checkout/store/order/orderDTO';
import { roomInfoDTO } from 'checkout/store/domains/room-info/dto';

import sagas from './sagas';
import createRootReducer from './reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

const getStore = (props, history = '' as unknown as History<unknown>) => {
  const {
    hotel,
    package: packageData,
    order: orderData,
    visa,
    isMobile,
    data,
    logo,
    roomInfo,
    platform,
    availableSearchTypes,
  } = props;

  const preloadedState = {
    view: {
      isMobile,
      topbarIndex: DEFAULT_TOPBAR_SLIDE,
      isTopbarExpanded: false,
      isRoomPopupOpened: false,
      isWebGlSupported: isWebGlSupported(),
      platform,
      showFilters: false,
      isWidgetShown: true,
      searchType: packageData.search_type,
      availableSearchTypes: availableSearchTypes || undefined,
      activeTouristForm: 0,
      ...getViewInitialState(),
    },
    hotel,
    data: {
      ...data,
      mockTourists: makeMockTourists(packageData),
    },
    roomInfo: roomInfoDTO(roomInfo),
    visa: visaDTO(visa),
    package: packageDTO({ ...packageData }),
    testimonials: {
      data: [],
      fetching: false,
    },
    order: orderDTO(orderData),
    logo,
    services: [],
    error: {
      isOpened: false,
    },
  };
  const store = createStore(
    createRootReducer(history),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    preloadedState as any,
    composeEnhancers(
      responsiveStoreEnhancer,
      applyMiddleware(...middlewares, routerMiddleware(history)),
    ),
  );
  sagaMiddleware.run(sagas);
  return store;
};

export default getStore;
